export const DefaultOnEndReachedThreshold = 0.8;
